import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from 'zenith/auth';

import { ConviviaLogoComponent } from '@core/component/convivia-logo/convivia-logo.component';
import { LayoutService } from '@core/service/layout.service';
import { WarningIconComponent } from '@shared/component/icons/warning-icon/warning-icon.component';
import { CardModule } from '@shared/component/card/card.module';
import { CoreModule } from '@core/core.module';

@Component({
  templateUrl: './root-fallback.component.html',
  styleUrl: './root-fallback.component.scss',
  imports: [ButtonModule, ConviviaLogoComponent, RouterModule, WarningIconComponent, CardModule, CoreModule],
})
export class RootFallbackComponent {
  readonly layoutService = inject(LayoutService);
  private readonly authService = inject(AuthService);

  closeSession(): void {
    this.authService.clearAuth();
  }
}
